<div class="form-group">
  @if (showLabel && (question?.question_copy || question?.email_version)) {
    <label
      class="form-group__label"
      [innerHtml]="question?.question_copy || question?.email_version">
    </label>
  }
  <div class="input-wrap">
    <input
      currencyMask
      [name]="uniqueControlName"
      [id]='uniqueId'
      [disabled]="readOnly"
      [placeholder]="question?.question_prompt"
      class="form-control"
      [(ngModel)]="value"
      (ngModelChange)="isEditModal ? null : saveValue()"
      (blur)="isEditModal ? saveValue() : null"
      [options]="maskOptions"
      >
      <div class="input-wrap-prepend">
        <div class="input-wrap-symbol">
          R
        </div>
      </div>
    </div>
  </div>
